import React from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { FileText } from 'lucide-react';
import { formatDate, formatDateTime } from '../../lib/dateUtils';

const STATUS = {
  pending: { label: 'Waiting for IT', cls: 'bg-amber-500' },
  confirmed: { label: 'Confirmed', cls: 'bg-emerald-600' },
  rejected: { label: 'Not accepted', cls: 'bg-red-600' },
};

export const PaymentRow = ({ p, onViewProof, children }) => (
  <div className="bg-white border rounded-xl p-4 flex flex-col md:flex-row md:items-center justify-between gap-3" data-testid={`payment-row-${p.payment_id}`}>
    <div className="text-sm space-y-0.5 min-w-0">
      <p className="font-semibold">{p.registration_number} · R{p.amount} · EFT ref <span className="font-mono">{p.eft_reference}</span></p>
      <p className="text-xs text-muted-foreground">Paid {p.date_paid} by {p.paid_by_name} ({p.paid_by_role === 'transport' ? 'Transport Operator' : 'Driver'}) · sent {formatDateTime(p.submitted_at)}</p>
      {p.status === 'confirmed' && <p className="text-xs text-emerald-700">Confirmed by {p.confirmed_by_name} on {formatDateTime(p.confirmed_at)} · active {formatDate(p.starts_at)} – {formatDate(p.expires_at)}</p>}
      {p.status === 'rejected' && <p className="text-xs text-red-700">Not accepted: {p.reject_reason}</p>}
    </div>
    <div className="flex items-center gap-2 flex-wrap">
      <Badge className={STATUS[p.status]?.cls} data-testid={`payment-status-${p.payment_id}`}>{STATUS[p.status]?.label}</Badge>
      <Button size="sm" variant="outline" className="rounded-full" onClick={() => onViewProof(p)} data-testid={`payment-proof-${p.payment_id}`}><FileText className="w-4 h-4 mr-1" /> Proof</Button>
      {children}
    </div>
  </div>
);
